const initialState = {
  tickets: [],
};

export default (state = initialState, action) => {
  const { type, data } = action;

  switch(type) {
  case 'USER_LISTING:TICKETS:SET':
    return {
      ...state,
      tickets: data,
    };
  default:
    return state;
  }
};
